module.exports = "<!-- <img src=\"../../../../../assets/sitios/motoselpaisa/img/buscar-repuesto.jpg\" class=\"img-responsive\"> -->\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/pdf-viewer/templates/pdf-viewer-base.view.html
 ** module id = 166
 ** module chunks = 0
 **/